import { createBrowserHistory } from 'history'

/**
 * Instance of browser history required by `react-router-dom`
 * and `@sentry/react` packages (only created in browser env).
 */
export const browserHistory =
  typeof window !== 'undefined'
    ? createBrowserHistory({
        basename: process.env.BASE_PATH,
      })
    : null
